import {
  Heading,
  ListItem,
  OrderedList,
  Stack,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { termsAndConditions } from "../constants/TermsAndConditions";
import { MetaTag } from "../utils/MetaTag";

const TermsAndConditions = () => {
  const termsList = termsAndConditions;

  return (
    <Stack
      gap={4}
      px={8}
      py={4}
      align="center"
      textAlign="justify"
      w="100%"
      h="100%"
    >
      <MetaTag
        title="Syarat dan Ketentuan | BisnisLink"
        description="Syarat dan Ketentuan BisnisLink"
      />

      <Heading as="h1" size="lg" mb={4}>
        Syarat dan Ketentuan
      </Heading>
      {termsList.map((terms, index) => (
        <Stack key={index} gap={2} w="100%" maxWidth="600px">
          {terms.content &&
            terms.content.map((content, index) => (
              <Text key={index} fontSize="sm" textAlign="justify">
                {content}
              </Text>
            ))}
          {terms.title && (
            <Heading as="h2" size="md" textAlign="start" color="red.500">
              {terms.title}
            </Heading>
          )}
          <UnorderedList px={4} mt={2}>
            {terms.list &&
              terms.list.map((text, index) => (
                <ListItem key={index} fontSize="sm" px={2}>
                  {text}
                </ListItem>
              ))}
          </UnorderedList>
          <OrderedList px={4} mt={2}>
            {terms.section &&
              terms.section.map((section, index) => (
                <ListItem key={index} gap={2} mt={2}>
                  <Heading as="h3" size="sm">
                    {section.title}
                  </Heading>
                  <UnorderedList px={4} mt={2}>
                    {section.subsection &&
                      section.subsection.map((subsection, index) => (
                        <ListItem key={index} gap={2}>
                          <Text fontSize="sm">{subsection.title}</Text>
                          <UnorderedList px={4} mt={2}>
                            {subsection.content &&
                              subsection.content.map((content, index) => (
                                <ListItem key={index} fontSize="sm" px={4}>
                                  {content}
                                </ListItem>
                              ))}
                          </UnorderedList>
                        </ListItem>
                      ))}
                  </UnorderedList>
                </ListItem>
              ))}
          </OrderedList>
        </Stack>
      ))}
    </Stack>
  );
};

export default TermsAndConditions;
